let layoutDefault = function({vGap,hGap,vRandom},groups,links){
    
    let vrand = vRandom?()=>Math.round(Math.random()*vRandom):()=>0
    let result = {}


    for(let group of groups){
        let i =0;
        if(result[group.id]) continue
        resultR(i,group.id,links,result)

    }
    
    let max=0;
    let min=0;
    let colNum;
    let colArray={};
    let maxRowNum=0;
    for(let i of Object.keys(result)){
        max = Math.max(result[i],max)
        min = Math.min(result[i],min)
        colArray[result[i]]?colArray[result[i]].push(i):colArray[result[i]]=[i]
        maxRowNum= Math.max(maxRowNum,colArray[result[i]].length)
    }
    colNum = max-min+1;
    let maxHeight = maxRowNum*vGap;
  
    for(let i of Object.keys(colArray)){
        let partNum = colArray[i].length;
        let partHeight = (maxHeight-partNum*vGap)/2;
        colArray[i].forEach((groupId,index)=>{
            let x = (i-min)*hGap
            let y = (index)*vGap+partHeight+vrand()
            let group = groups.find(v=>v.id == groupId)
            group.position=[x,y]
        })
        
    }
    
}
function resultR(i,id,links,result){
    
    result[id]=i;
    let groupsAfter = links.filter(v=>v.source.groupId == id).map(v=>v.target.groupId)
    for(let idnext of groupsAfter){
        // console.log(id,idnext,result[id],result[idnext])
        if(typeof result[idnext] !== "undefined"){
            result[id] = Math.min(result[id],result[idnext]-1)
            // console.log("result[id]",result[id])
            continue;
        }

        
        resultR(i+1,idnext,links,result)
    }
    return result;
}

export default layoutDefault


// WEBPACK FOOTER //
// ./src/assets/tflow/layout/layoutDefault.js